import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { QueueOverview } from '@/components/jobs/queue-overview';
import { recordVisit } from '@/hooks/useVisitHistory';

export const meta = {
  label: 'Job Queues',
  order: 10,
  section: 'Jobs',
  sectionRoot: true,
};

export const JobsPage = () => {
  const location = useLocation();

  useEffect(() => {
    recordVisit('/jobs', 'Job Queues', 'job');
  }, []);

  const searchParams = new URLSearchParams(location.search);
  if (searchParams.get('tab') === 'search') {
    searchParams.delete('tab');
    return <Navigate replace to={`/job-worker-traces${searchParams.toString() ? `?${searchParams}` : ''}`} />;
  }

  return (
    <div>
      <h2 className='font-mediumbold mb-4 text-xl text-neutral-900'>Job Queues</h2>
      <QueueOverview />
    </div>
  );
};
